import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {KTSVG, toAbsoluteUrl} from '../../helpers'
import {useIntl} from 'react-intl'
import {DataTables, PurchaceProposalRequestModal, KTCard, KTCardHeader, KTCardBody} from '..'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {
  purchaseProposalRequestSendMail,
  purchaseProposalRequestSubInfo,
} from '../../redux/slices/purchase.slice'

const PurchaseProposalRequest = ({data, id}) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const {mail, subInfo} = useSelector((state) => state.purchase)

  const [showPurchaseProposalRequestModal, setShowPurchaseProposalRequestModal] = useState(false)
  const [showMailModal, setShowMailModal] = useState(false)
  const [mailId, setMailId] = useState(0)
  const [showSubInfoModal, setShowSubInfoModal] = useState(false)
  const handleSendMail = () => {
    setShowMailModal(false)
    dispatch(purchaseProposalRequestSendMail({id: mailId}))
  }

  const onClickSubInfo = (id) => {
    dispatch(purchaseProposalRequestSubInfo({id}))
  }

  useEffect(() => {
    if (mail) {
      setShowMailModal(true)
    }
  }, [mail])

  useEffect(() => {
    if (subInfo) {
      setShowSubInfoModal(true)
    }
  }, [subInfo])

  return (
    <>
      <KTCard>
        <KTCardHeader className='p-0'>
          <div className='card-toolbar'>
            <button
              className='btn btn-sm btn-light-success'
              onClick={() => setShowPurchaseProposalRequestModal(true)}
            >
              <KTSVG path='/images/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              {intl.formatMessage({id: 'BUTTON.PURCHASEPROPOSALREQUEST.ADD'})}
            </button>
          </div>
        </KTCardHeader>
        <KTCardBody className='p-0 pt-5'>
          {data && data?.length > 0 && (
            <DataTables
              columns={[
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.COMPANYNAME',
                  }),
                  prop: 'proposalCompanyName',
                  isSortable: true,
                  isFilterable: true,
                  cell: (props) => {
                    return (
                      <div
                        className='cursor-pointer text-hover-primary d-flex align-items-center justify-content-center'
                        onClick={() => onClickSubInfo(props?.id)}
                      >
                        {props?.proposalCompanyName}
                      </div>
                    )
                  },
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.DESCRIPTION',
                  }),
                  prop: 'description',
                  isSortable: true,
                  isFilterable: true,
                  cell: (props) => {
                    return (
                      <div
                        className='cursor-pointer text-hover-primary d-flex align-items-center justify-content-center'
                        onClick={() => onClickSubInfo(props?.id)}
                      >
                        {props?.description}
                      </div>
                    )
                  },
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.NOTE',
                  }),
                  prop: 'note',
                  isSortable: true,
                  isFilterable: true,
                  cell: (props) => {
                    return (
                      <div
                        className='cursor-pointer text-hover-primary d-flex align-items-center justify-content-center'
                        onClick={() => onClickSubInfo(props?.id)}
                      >
                        {props?.note}
                      </div>
                    )
                  },
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.LATESTDATEPROPOSAL',
                  }),
                  prop: 'latestDateProposal',
                  isSortable: true,
                  isFilterable: true,
                  cell: (props) => {
                    return (
                      <div
                        className='cursor-pointer text-hover-primary d-flex align-items-center justify-content-center'
                        onClick={() => onClickSubInfo(props?.id)}
                      >
                        {props?.latestDateProposal
                          ? intl.formatDate(new Date(props?.latestDateProposal), {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })
                          : '-'}
                      </div>
                    )
                  },
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.MAIL',
                  }),
                  prop: 'id',
                  cell: (props) => {
                    return (
                      <div
                        className='cursor-pointer text-hover-primary d-flex align-items-center justify-content-center'
                        onClick={() => {
                          setShowMailModal(true)
                          setMailId(props?.id)
                        }}
                      >
                        <KTSVG
                          path='/images/icons/duotune/communication/com002.svg'
                          className='svg-icon-2'
                        />
                      </div>
                    )
                  },
                  isSortable: true,
                  isFilterable: true,
                  alignment: {
                    horizontal: 'right',
                  },
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.PROPOSALFILEURL',
                  }),
                  prop: 'proposalFileUrl',
                  cell: (props) => {
                    if (props?.fileUrl) {
                      return (
                        <a
                          href={props?.fileUrl}
                          target='_blank'
                          rel='noreferrer'
                          className='d-flex align-items-center text-end justify-content-end'
                        >
                          <div className='symbol symbol-40px'>
                            <span className='symbol-label'>
                              <img
                                src={toAbsoluteUrl('/images/icons/duotune/files/fil021.svg')}
                                className='h-50 align-self-center'
                                alt=''
                              />
                            </span>
                          </div>
                          <span>{intl.formatMessage({id: 'BUTTON.DOWNLOAD'})}</span>
                        </a>
                      )
                    } else {
                      return '-'
                    }
                  },
                  isSortable: true,
                  isFilterable: true,
                  alignment: {
                    horizontal: 'right',
                  },
                },
              ]}
              data={data}
              exportTitle={intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS'})}
            />
          )}
        </KTCardBody>
      </KTCard>

      <PurchaceProposalRequestModal
        onOpen={showPurchaseProposalRequestModal}
        onClose={() => setShowPurchaseProposalRequestModal(false)}
        data={data}
        id={id}
      />

      <Modal
        className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
        id='kt_inbox_compose'
        role='dialog'
        data-backdrop='false'
        aria-hidden='true'
        tabIndex='-1'
        show={showMailModal}
        animation={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        onHide={() => setShowMailModal(false)}
      >
        <div className='modal-content'>
          <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
            <h5 className='fw-bold m-0'>{intl.formatMessage({id: 'MAIL.TITLE'})}</h5>
            <div className='d-flex ms-2'>
              <div
                className='btn btn-icon btn-sm btn-light-primary ms-2'
                data-bs-dismiss='modal'
                onClick={() => setShowMailModal(false)}
              >
                <KTSVG className='svg-icon-1' path='/images/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
          </div>

          <div className='d-block text-center py-5 ps-8 pe-5 '>
            <div className='d-block'>
              <KTSVG
                className='text-success'
                svgClassName='w-125px h-125px'
                path='/images/icons/duotune/communication/com002.svg'
              />
            </div>
            <div className='d-block text-center mt-6 mb-13'>
              <h1 className='text-muted'>
                {mail
                  ? intl.formatMessage({id: 'MAIL.DESCRIPTION.SUCCESS'})
                  : intl.formatMessage({id: 'MAIL.DESCRIPTION'})}
              </h1>
            </div>
          </div>

          {!mail && (
            <div className='d-flex align-items-center justify-content-center py-5 ps-8 pe-5 border-top'>
              <div className='d-flex align-items-center me-3'>
                <button className='btn btn-light me-3' onClick={() => setShowMailModal(false)}>
                  {intl.formatMessage({id: 'BUTTON.CLOSE'})}
                </button>
                <button className='btn btn-success' onClick={handleSendMail}>
                  {intl.formatMessage({id: 'BUTTON.MAIL'})}
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
        id='kt_inbox_compose'
        role='dialog'
        data-backdrop='false'
        aria-hidden='true'
        tabIndex='-1'
        show={showSubInfoModal}
        animation={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        onHide={() => setShowSubInfoModal(false)}
        size='xl'
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>{subInfo?.description}</h5>
            <div className='d-flex ms-2'>
              <div
                className='btn btn-icon btn-sm btn-light-primary ms-2'
                data-bs-dismiss='modal'
                onClick={() => setShowSubInfoModal(false)}
              >
                <KTSVG className='svg-icon-1' path='/images/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
          </div>
        </div>
        <div className='modal-body'>
          <div dangerouslySetInnerHTML={{__html: subInfo?.content}} />
        </div>

        <div className='modal-footer'>
          <a
            href={subInfo?.applicationLink}
            target='_blank'
            rel='noreferrer'
            className='d-flex align-items-center text-end justify-content-end'
          >
            <div className='symbol symbol-40px'>
              <span className='symbol-label'>
                <img
                  src={toAbsoluteUrl('/images/icons/duotune/files/fil021.svg')}
                  className='h-50 align-self-center'
                  alt=''
                />
              </span>
            </div>
            <span>{intl.formatMessage({id: 'BUTTON.ATTACHMENT'})}</span>
          </a>
        </div>
      </Modal>
    </>
  )
}

PurchaseProposalRequest.propTypes = {
  collapse: PropTypes.bool,
  SourceId: PropTypes.number,
  SourceTypeId: PropTypes.number,
}

export {PurchaseProposalRequest}
